// Index of 1 refer to the locale in the url (eg: ID, TH)
// Check the index of 1 in the url to determine the section

export const getUrlSection = (reqPath: string): string => {
  const routeArray = reqPath.split('?')[0].split('/'); // url without the query string
  return routeArray[1].length === 2 ? routeArray[2] : routeArray[1];
};
